var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"平台介绍"}},[_c('div',{staticClass:"p-4 leading-5"},[_vm._v("平台介绍内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }